import React, { memo } from 'react';
import { prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';

import { OverflowSlider } from '../OverflowSlider';
import { GridPagingSlider } from '../GridPagingSlider';

// Duplicate of GoldenChipsBalances components.
// Since we need to use it for all accordion tables - these components moved here.

export const Games = memo(({ selectedGames }: { selectedGames: string[] }) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    if (!isDesktop) {
        return (
            <OverflowSlider gameCodes={selectedGames} />
        );
    }

    return (
        <GridPagingSlider gameCodes={selectedGames} />
    );
});
